import {
  ListenerEvent,
  IncomingMessage,
  MessageHandler
} from '@carvana/merch-native';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import ActionTypes from '~/constants/actionTypes';
import getGeoLocationApi from '~/services/common/getGeoLocationApi';

type UpdateGeolocationMessage = IncomingMessage<
  ListenerEvent,
  {
    city?: string;
    state?: string;
    zip: string;
  }
>;

function isUpdateGeolocationMessage(
  message: IncomingMessage<ListenerEvent, any>
): message is UpdateGeolocationMessage {
  return (
    message.event === ListenerEvent.UpdateGeolocation &&
    message.payload.zip != null
  );
}

export default function useUpdateGeolocationHandler(): MessageHandler<ListenerEvent> {
  const dispatch = useDispatch();

  return useMemo(
    () =>
      new MessageHandler(
        isUpdateGeolocationMessage,
        (message: UpdateGeolocationMessage) => {
          const geoLocationApi = getGeoLocationApi();

          geoLocationApi.setGeoLocation(message.payload.zip).then(location => {
            dispatch({
              type: ActionTypes.setGeolocation,
              payload: location
            });
          });
        }
      ),
    [dispatch]
  );
}
